/* ==========================================================================
   Lookbook — behaviour for the lookbook-* sections.
   Hotspot open/close, slide counter, and theme-editor hooks. Rails and the
   reveal animation come from hp-v2.js, which lookbook-assets loads first.
   Guarded so it stays a no-op if included more than once.
   ========================================================================== */
(function () {
  if (window.LOOKBOOK) return;

  var LB = {};
  window.LOOKBOOK = LB;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function closeSpots(scope, except) {
    var open = (scope || document).querySelectorAll('.lb-spot.is-open');
    Array.prototype.forEach.call(open, function (spot) {
      if (spot === except) return;
      spot.classList.remove('is-open');
      var btn = spot.querySelector('[data-lb-spot-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      var slide = btn && btn.closest('.lb-slide');
      if (slide) slide.classList.remove('has-open-spot');
    });
  }

  function openSpot(spot) {
    var btn = spot.querySelector('[data-lb-spot-toggle]');
    var slider = spot.closest('[data-lb-slider]');
    closeSpots(slider || document, spot);
    spot.classList.add('is-open');
    if (btn) {
      btn.setAttribute('aria-expanded', 'true');
      var slide = btn.closest('.lb-slide');
      if (slide) slide.classList.add('has-open-spot');
    }
    // Remember where the rail sat, so the scroll the browser performs to
    // reveal the freshly focused button is not mistaken for a user swipe.
    if (slider) {
      var rail = slider.querySelector('[data-hpv2-rail]');
      if (rail) slider.__lbOpenScroll = rail.scrollLeft;
    }
  }

  LB.closeAll = closeSpots;

  /* ---- Sliders ------------------------------------------------------------ */
  LB.sliders = function (root) {
    var sliders = (root || document).querySelectorAll('[data-lb-slider]:not([data-lb-ready])');

    Array.prototype.forEach.call(sliders, function (slider) {
      slider.setAttribute('data-lb-ready', 'true');

      // Focusing a hotspot on click would make the browser scroll the rail to
      // reveal it, shifting the slide under the pointer. Suppress the implicit
      // focus here and re-apply it without scrolling once the card is open.
      slider.addEventListener('mousedown', function (event) {
        if (event.target.closest('[data-lb-spot-toggle]')) event.preventDefault();
      });

      slider.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-lb-spot-toggle]');
        if (toggle) {
          event.preventDefault();
          var spot = toggle.closest('.lb-spot');
          if (spot.classList.contains('is-open')) {
            closeSpots(slider);
          } else {
            openSpot(spot);
            try {
              toggle.focus({ preventScroll: true });
            } catch (e) {
              /* Older browsers ignore the option; the nudge guard covers them. */
            }
          }
          return;
        }
        // Clicks inside an open card (e.g. the product link) pass through.
        if (event.target.closest('.lb-spot__card')) return;
        closeSpots(slider);
      });

      var rail = slider.querySelector('[data-hpv2-rail]');
      var current = slider.querySelector('[data-lb-current]');
      if (!rail) return;

      var ticking = false;

      function update() {
        ticking = false;
        var slides = rail.children;
        if (!slides.length) return;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        var width = slides[0].getBoundingClientRect().width + gap;
        var index = width > 0 ? Math.round(rail.scrollLeft / width) : 0;
        index = Math.max(0, Math.min(slides.length - 1, index));

        Array.prototype.forEach.call(slides, function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        if (current) current.textContent = pad(index + 1);
      }

      rail.addEventListener('scroll', function () {
        // A hotspot card anchored to a slide that is scrolling away looks
        // broken, so close it once the rail has genuinely moved. Small
        // shifts from the browser revealing a focused control are ignored.
        if (slider.querySelector('.lb-spot.is-open')) {
          var from = slider.__lbOpenScroll;
          if (typeof from !== 'number' || Math.abs(rail.scrollLeft - from) > 80) {
            closeSpots(slider);
          }
        }
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }, { passive: true });

      window.addEventListener('resize', update);
      update();

      LB.scrollTo = LB.scrollTo || function (slide) {
        var r = slide.closest('[data-hpv2-rail]');
        if (!r) return;
        r.scrollTo({ left: slide.offsetLeft - r.offsetLeft, behavior: 'smooth' });
      };
    });
  };

  /* ---- Global dismissal -------------------------------------------------- */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-lb-slider]')) return;
    closeSpots(document);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeSpots(document);
  });

  /* ---- Boot -------------------------------------------------------------- */
  LB.init = function (root) {
    LB.sliders(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { LB.init(); });
  } else {
    LB.init();
  }

  /* ---- Theme editor -------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (event) {
    LB.init(event.target);
  });

  // Selecting a look or hotspot block in the editor brings it into view.
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var slide = target.closest('.lb-slide');
    if (!slide) return;
    if (LB.scrollTo) LB.scrollTo(slide);
    var spot = target.closest('.lb-spot');
    if (spot) {
      window.setTimeout(function () { openSpot(spot); }, 350);
    } else {
      closeSpots(slide);
    }
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.lb-spot')) closeSpots(document);
  });
})();
